import SectionHeading from "@/components/base/SectionHeading";
import { characters } from "@/mocks/home";

export default function CharactersSection() {
  return (
    <section id="characters" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="角色图谱"
          title="黑料短剧角色介绍与人物关系"
          desc="四条主线角色各自揣着不愿说出口的版本，把他们放在同一张关系网里，很多“巧合”就有了答案。"
          accent="accent"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {characters.map((person) => (
            <article
              key={person.name}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="h-64 w-full overflow-hidden bg-secondary-200">
                <img
                  src={person.image}
                  alt={`黑料短剧角色${person.name}剧照`}
                  title={`黑料短剧 角色介绍 ${person.name}`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex items-baseline gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{person.name}</h3>
                  <span className="text-xs font-medium text-accent-600">{person.role}</span>
                </div>
                <span className="mt-2 inline-block rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
                  {person.trait}
                </span>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{person.desc}</p>
                <p className="mt-3 border-t border-background-200 pt-3 text-xs leading-relaxed text-foreground-500">
                  <span className="font-semibold text-foreground-700">人物关系：</span>
                  {person.relation}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}